"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _modalActions = require("../../../redux/actions/modalActions");
var _MarginDepositWithdrawComponent = _interopRequireDefault(require("./MarginDepositWithdrawComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openMarginDepositModal: function openMarginDepositModal() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.MARGIN_DEPOSIT));
    },
    openMarginWithdrawModal: function openMarginWithdrawModal() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.MARGIN_WITHDRAW));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(_MarginDepositWithdrawComponent["default"]);